import 'colresizable/colResizable-1.6.min';

let Masonry = require('masonry-layout');

$(document).ready(function (e) {

    let $body = $('body');

    // if($('.sidebar-table-container').length){
    //     $.ajax({
    //         type : 'GET',
    //         url : '/sidebar/menu',
    //         success : function(res){
    //             let $sidebar_container = $('.sidebar-table-container'),
    //                 $loader = $sidebar_container.find('.sidebar-loader');
    //
    //             $loader.remove();
    //             $sidebar_container.append(res);
    //         }
    //     })
    // }

    if ($('.browse-cards').length && !is_mobile) {
        new Masonry('.browse-cards', {});
    }

    var $browse_cards = $('.browse-cards');

    if (is_mobile && $browse_cards.length) {
        var cards_loading = false,
            all_loaded = false;

        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() === $(document).height()) {
                let $page_container = $('.page-container'),
                    loaded = $page_container.attr('data-loaded'),
                    table = $page_container.attr('data-table-id'),
                    searching = $('#search-records').val().length;

                if (all_loaded || cards_loading || searching) {
                    return;
                }

                cards_loading = true;

                // Get the current URL and extract the query parameters if any
                let currentUrl = new URL(window.location.href);
                let params = currentUrl.searchParams;
                let paramObj = {};

                // Convert the search params to an object
                params.forEach((value, key) => {
                    paramObj[key] = value;
                });

                // Add the 'skip' parameter
                paramObj['skip'] = loaded;

                $.ajax({
                    type: 'GET',
                    url: '/infinite-browse/' + table + '/card',
                    data: paramObj,  // Pass the parameters with the request
                    success: function (res) {
                        cards_loading = false;
                        let count = parseInt(loaded) + parseInt(res.count);
                        $page_container.attr('data-loaded', count);
                        $page_container.find('.browse-cards').append(res.records);

                        if (!parseInt(res.count)) {
                            all_loaded = true;
                        }
                    }
                });
            }
        });
    }

    $('.section-link').overflowing('.related-tabs');

    let $overflowed_sections = $('.section-link.overflowing');
    if ($overflowed_sections.length) {
        $('.section-link-container').removeClass('d-none');
    }
    $overflowed_sections.each(function (index, element) {
        $(element).detach().appendTo('.section-link-dropdown')
    });
    $('.related-tabs').removeClass('invisible');

    $(".resizeable-table").each(function (index, $table) {
        let type = $($table).attr('data-type'),
            ignore = [],
            $head = $($table).find('thead'),
            count = $head.find('th').length;
        // parent_width = $($table).parents('.table_container').outerWidth(),
        // th_first = $($table).find('thead').find('th:nth-child(1)').outerWidth(),
        // th_second = $($table).find('thead').find('th:nth-child(2)').outerWidth(),
        // th_last =  $($table).find('thead').find('th:last-child').outerWidth(),
        // width = parent_width - th_first - th_second - th_last,
        // min_width = width / ( count - 3);
        //

        if ($head.hasClass('has-delete')) {
            ignore = [0];
        }

        if (type === 'browse') {
            if ($head.hasClass('has-buttons') && $head.hasClass('has-delete')) {
                ignore = [0, 1];
            }

            if ($head.hasClass('has-buttons') || $head.hasClass('has-delete')) {
                ignore = [0];
            }
        }

        $($table).colResizable({
            // minWidth: min_width,
            // resizeMode : 'overflow',
            disabledColumns: ignore,
            liveDrag: true,
            onResize: function (e) {
                let $container = $(e.currentTarget),
                    $headers = $container.find('thead th');

                $headers.each(function (index, $header) {
                    let id = $($header).attr('data-col'),
                        section_id = $($header).attr('data-section'),
                        type = section_id ? 'section' : 'browse';

                    if (id && id.length) {
                        let width = $($header).outerWidth();

                        $.ajax({
                            type: 'POST',
                            url: '/tables/fields/width',
                            data: {
                                id,
                                width,
                                section_id,
                                type
                            },
                            success: function (res) {
                                console.log(res);
                            }
                        })
                    }
                });
            }
        });
    });

    $('table.button-container').colResizable({
        // minWidth: min_width,
        // resizeMode : 'overflow',
        liveDrag: true,
        gripInnerHtml: "<div class='grip'></div>",
        onResize: function (e) {
            let $container = $(e.currentTarget),
                $headers = $container.find('tbody td'),
                type = '',
                source_id = '';

            if ($container.hasClass('section-insert-container')) {
                type = 'section_insert';
            } else {
                type = 'quick_add';
            }

            source_id = $container.attr('data-source-id');

            $headers.each(function (index, $header) {
                let id = $($header).attr('data-field');
                if (id && id.length) {
                    let width = $($header).outerWidth();

                    $.ajax({
                        type: 'POST',
                        url: '/tables/fields/width',
                        data: {
                            id,
                            width,
                            source_id,
                            type
                        },
                        success: function (res) {
                            console.log(res);
                        }
                    })
                }
            });
        }
    });

    $(document).on('click', '.btn-link-accordion', '.sorting-accordion', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $('.sorting-accordion').find('.collapse').removeClass('show');
        $(this).siblings('.collapse').toggleClass('show');
    });

    $(document).on('click', '.ascending, .descending', function (e) {
        let name = $(this).data('field-name'),
            order = $(this).data('sort-by'),
            type = $(this).data('type'),
            $btn = $('#browse-sort-btn'),
            field = $(this).parents('.sort-field').find('.btn-link').text().trim(),
            order_translation = {
                'asc': $btn.attr('data-asc'),
                'desc': $btn.attr('data-desc'),
            };

        let text = `${field} / ${order_translation[order]}`;

        $btn.text(text);
        $('.clear-sorting').removeClass('d-none');

        $('.ascending, .descending').removeClass('active');
        $(this).addClass('active');

        $('.sorting-dropdown').attr('data-sort-field', name).attr('data-sort-order', order);
    });

    $(document).on('click', '.clear-sorting', function (e) {
        $(this).addClass('d-none');
        $('#browse-sort-btn').text($(this).data('text'));
        $('.sorting-dropdown').attr('data-sort-field', '').attr('data-sort-order', '');
        $('.sorting-dropdown').find('.ascending').removeClass('active');
        $('.sorting-dropdown').find('.descending').removeClass('active');
    });

    let confPopup = $('#delTabPop');
    let acceptDel = $('#accTableDel');
    let cancelDel = $('#cancelTableDel');
    let DelUrl, tid;

    $('#deleteTable').on('click', function (e) {
        e.preventDefault();
        confPopup.show();
        DelUrl = $(this).attr('href');
        tid = $(this).data('tid');
    });

    cancelDel.on('click', function (e) {

        e.preventDefault();
        confPopup.hide();

    });

    acceptDel.on('click', function (e) {

        e.preventDefault();
        confPopup.hide();

        let data = {
            tid: tid
        };

        $.ajax({

            url: DelUrl,
            type: 'DELETE',
            data: data,
            success: function (res) {
                if (res.success) {
                    toastr.success("Table has been deleted!");
                    setTimeout(function (e) {
                        window.location.href = `/customize`;
                    }, 3000)
                } else {
                    toastr.error(`${res.message}`);
                }

            },
            error: function (xhr, status, error) {
                let res = xhr.responseText;
                console.log(res)
            }
        });

    });

    $('.toggle-records').on('click', function (e) {
        e.preventDefault();
        $('.toggle-records').removeClass('checked');
        $('.toggle-records').find('.fa-check').addClass('d-none');
        $(this).addClass('checked');
        $(this).find('.fa-check').removeClass('d-none');
        let type = $(this).attr('data-type');
        window.location = getUrlParams("access", type);
    });

    /**
     * get URL parameters
     * @param paramName
     * @param newValue
     * @returns {string}
     */
    function getUrlParams(paramName, newValue) {
        const url = window.location.href;
        const urlParts = url.split("?");
        if (urlParts.length >= 2) {
            const params = urlParts[1].split("&");
            let found = false;
            for (let i = 0; i < params.length; i++) {
                const paramParts = params[i].split("=");
                if (paramParts[0] === paramName) {
                    params[i] = paramName + "=" + newValue;
                    found = true;
                    break;
                }
            }
            if (!found) {
                params[params.length] = `${paramName}=${newValue}`;
            }
            return urlParts[0] + "?" + params.join("&");
        } else {
            return url + "?" + paramName + "=" + newValue;
        }
    }
});